/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Sku_Regenerate_TitleInputs */

const vi_packaging_material_sku_regenerate_title = /** @type {(inputs: Packaging_Material_Sku_Regenerate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự sinh lại SKU từ tên vật tư`)
};

/**

* @param {Packaging_Material_Sku_Regenerate_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_sku_regenerate_title = /** @type {((inputs?: Packaging_Material_Sku_Regenerate_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Sku_Regenerate_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_sku_regenerate_title(inputs)
});